import { Injectable } from '@angular/core';
import { ApiService } from '@app/services/api.service';
import { MagicLinkInterface } from '@app/interfaces/magic-link.interface';

@Injectable({
    providedIn: 'root',
})
export class MagicLinksService extends ApiService<MagicLinkInterface> {
    // @API magic-links
    protected serviceName = 'magic-links';

    constructor() {
        super();
        this.initConnection();
    }
}
